import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const processDatasourceDatasubjectTransferingLegal = createCrudVuexModule({
  namespaced: true,
  path: "/quick-hierarchy/process-datasource-datasubject-transfering-legal",

  state: {
    editedEntity: undefined,
  },
  mutations: {
    editedEntity: (state, value) => (state.editedEntity = value),
  },
  getters: {
    copingEntity: (state) => state.copingEntity ?? {},
  },
  actions: {
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/quick-hierarchy/process-datasource-datasubject-transfering-legal`, payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/quick-hierarchy/process-datasource-datasubject-transfering-legal`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async multipleDelete({ state, commit }, array) {
      const success = [];
      const failed = [];

      for (const item of array) {
        await rest.delete(`/quick-hierarchy/process-datasource-datasubject-transfering-legal/${item._id}`);
      }

      commit("deleteOperationResult", {
        success: success,
        failed: failed,
      });
    },
  },
});

export const workspaceProcessDatasourceDatasubjectTransferingLegal = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/quick-hierarchy/process-datasource-datasubject-transfering-legal",

  state: {
    editedEntity: undefined,
  },
  mutations: {
    editedEntity: (state, value) => (state.editedEntity = value),
  },
  getters: {
    copingEntity: (state) => state.copingEntity ?? {},
  },
  actions: {
    async save({ dispatch, getters }, payload) {
      payload = await dispatch("preparePayload", {
        editedEntity: getters.editedEntity,
        form: payload,
      });

      if (payload._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
    },
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);

        const response = await rest.post(`/workspace/quick-hierarchy/process-datasource-datasubject-transfering-legal`, payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);

        const response = await rest.put(`/workspace/quick-hierarchy/process-datasource-datasubject-transfering-legal`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async multipleDelete({ state, commit }, array) {
      const success = [];
      const failed = [];

      for (const item of array) {
        await rest.delete(`/workspace/quick-hierarchy/process-datasource-datasubject-transfering-legal/${item._id}`);
      }

      commit("deleteOperationResult", {
        success: success,
        failed: failed,
      });
    },
  },
});
